import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConversionPath = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_6201_13123",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_6201_13123)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 21C18.35 21 17.7667 20.8125 17.25 20.4375C16.7333 20.0625 16.375 19.5833 16.175 19H11C9.9 19 8.95833 18.6083 8.175 17.825C7.39167 17.0417 7 16.1 7 15C7 13.9 7.39167 12.9583 8.175 12.175C8.95833 11.3917 9.9 11 11 11H13C13.55 11 14.0208 10.8042 14.4125 10.4125C14.8042 10.0208 15 9.55 15 9C15 8.45 14.8042 7.97917 14.4125 7.5875C14.0208 7.19583 13.55 7 13 7H7.825C7.60833 7.58333 7.24583 8.0625 6.7375 8.4375C6.22917 8.8125 5.65 9 5 9C4.16667 9 3.45833 8.70833 2.875 8.125C2.29167 7.54167 2 6.83333 2 6C2 5.16667 2.29167 4.45833 2.875 3.875C3.45833 3.29167 4.16667 3 5 3C5.65 3 6.22917 3.1875 6.7375 3.5625C7.24583 3.9375 7.60833 4.41667 7.825 5H13C14.1 5 15.0417 5.39167 15.825 6.175C16.6083 6.95833 17 7.9 17 9C17 10.1 16.6083 11.0417 15.825 11.825C15.0417 12.6083 14.1 13 13 13H11C10.45 13 9.97917 13.1958 9.5875 13.5875C9.19583 13.9792 9 14.45 9 15C9 15.55 9.19583 16.0208 9.5875 16.4125C9.97917 16.8042 10.45 17 11 17H16.175C16.3917 16.4167 16.7542 15.9375 17.2625 15.5625C17.7708 15.1875 18.35 15 19 15C19.8333 15 20.5417 15.2917 21.125 15.875C21.7083 16.4583 22 17.1667 22 18C22 18.8333 21.7083 19.5417 21.125 20.125C20.5417 20.7083 19.8333 21 19 21ZM5 7C5.28333 7 5.52083 6.90417 5.7125 6.7125C5.90417 6.52083 6 6.28333 6 6C6 5.71667 5.90417 5.47917 5.7125 5.2875C5.52083 5.09583 5.28333 5 5 5C4.71667 5 4.47917 5.09583 4.2875 5.2875C4.09583 5.47917 4 5.71667 4 6C4 6.28333 4.09583 6.52083 4.2875 6.7125C4.47917 6.90417 4.71667 7 5 7Z",
			fill: "#D9D9D9"
		})
	})]
});
export default SvgConversionPath;
